export enum RootContentTypes {
    HOMEPAGE = 'fiverr-guides-homepage',
    CATEGORY = 'fiverr-guides-category',
    ARTICLE = 'fiverr-guides-article',
}

export const ABSOLUTE_ROOT_PATH = '/resources/guides';
